import { Row, Col, Button } from 'reactstrap';
import CustomInput from '@myComponents/CustomInput';
import CustomSelect from '@myComponents/CustomSelect';
import { MdOutlineDownload } from 'react-icons/md';

// ** Table Header
export const CustomHeader = ({ headerOptions, headerOptionsModal, control, errors, handleDownload, loadingDownload }) => {
  const rowsPerPage = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 }
  ];
  return (
    <div className="invoice-list-table-header w-100 me-1 ms-50 mt-2 mb-75">
      <Row>
        <Col xl="6" className="d-flex align-items-center p-0">
          {!headerOptions?.notShowRowList && (
            <div
              className="d-flex align-items-center"
              style={{
                width: 250
              }}
            >
              <label htmlFor="project_perPage" style={{paddingRight: 10}}>Mostrar </label>
              <CustomSelect
                id="project_perPage"
                name="perPage"
                label=""
                control={control}
                options={rowsPerPage}
                error={errors?.perPage}
                loading={false}
                bottom
              />
              <label htmlFor="project_perPage" style={{paddingLeft: 10}}> Entradas</label>
            </div>
          )}
          {handleDownload && (
          <div className="d-flex align-items-center table-header-actions">
            <Button
              className="add-new-user"
              color="primary"
              onClick={handleDownload}
            >
              {
                loadingDownload && (<span className="jm_loader"></span>)
              }
              
              <MdOutlineDownload style={{width: '24px', height: '24px', marginRight: '10px'}}/>
              Descargar Data
            </Button>
          </div>) 
          }
        </Col>
        <Col
          xl="6"
          className="d-flex align-items-sm-center justify-content-xl-end justify-content-start flex-xl-nowrap flex-wrap flex-sm-row flex-column pe-xl-1 p-0 mt-xl-0 mt-1"
        >
          <div className="d-flex align-items-center mb-sm-0 mb-0 me-1">
            <div className="px-1">Buscar:</div>{' '}
            <CustomInput
              id="project_search_term"
              name="q"
              placeholder=""
              control={control}
              error={errors?.q}
              label=""
              type="text"
              bottom
            />
          </div>
          {headerOptions && (
            <div className="d-flex align-items-center table-header-actions">
              <Button
                className="add-new-user"
                color="primary"
                onClick={headerOptions.handle}
              >
                {headerOptions.name}
              </Button>
            </div>
          )}
          {headerOptionsModal && (
            <div className="d-flex align-items-center table-header-actions"style={{paddingLeft: '10px'}}>
              <Button
                className="add-new-user"
                color="primary"
                onClick={headerOptionsModal.handle}
              >
                {headerOptionsModal.name}
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};
